export class Mask {

  #array = [];

  /**
 * @param {(String | Number[] | Boolean[] | Mask)} values
 */
  constructor(values) {
    this.#array = Mask.#toArray(values);
  }

  asIntArray= ()=> this.asArray().reduce((p,x,i)=> x ? [...p,i] : p, []);
  asArray = () => Array.from(this.#array, v => v === undefined ? false : v);
  asString = () => this.asArray().reduce((p, x, i, a) => {
    let res = "";
    if (i == a.length - 1) {
      res = i > 1 && a[i - 1] ? '-' : "";
      res += (i).toString();
    } else if (p.last && x) {
      res = "";
    } else if (p.last && !x) {
      res = i > 1 && a[i - 2] ? '-' + (i - 1).toString() + '|' : '|';
    } else if (!p.last && x) {
      res = i.toString();
    } else if (!p.last && !x) {
      res = "";
    }
    return { last: x, res: p.res + res }
  }, { last: null, res: "" }).res;

  /**
* @param {String} str
*/
  static #parseString = (str) => {
    let values = [];
    let ranges = str.split('|');
    ranges.forEach(r => {
      if (r.includes('-')) {
        let from = parseInt(r.split('-')[0]);
        let to = parseInt(r.split('-')[1]);
        for (let i = from; i <= to; i++) {
          values[i] = true;
        }
      } else {
        values[parseInt(r)] = true;
      }
    });
    return values;
  }

  /**
 * @param {(String | any[] | Mask)} values
 */
  static #toArray = (values) => {
    let res = [];
    switch (typeof values) {
      case "string":
        res = Mask.#parseString(values);
        break;
      case "object":
        if (Array.isArray(values)) {
          values.forEach((x, i) => {
            switch (typeof x) {
              case "number":
                res[parseInt(x)] = true;
                break;
              case "boolean":
                res[i] = x;
                break;
              default:
                throw 'Invalid params!';
            }
          });
        } else if (values instanceof Mask) {
          res = values.asArray();
        } else {
          throw 'Invalid params!';
        }
        break;
      default:
        throw 'Invalid params!';
    };
    return Array.from(res, v => v === undefined ? false : v);
  }

  /**
* @param {(String | Number[] | Boolean[] | Mask)} values
*/
  add = (values) => {
    let newValues = Mask.#toArray(values);
    newValues.forEach((x, i) => this.#array[i] = x ? true : this.#array[i]);
    return this.asArray();
  };

  /**
* @param {(String | Number[] | Boolean[] | Mask)} values
*/
  remove = (values) => {
    let newValues = Mask.#toArray(values);
    newValues.forEach((x, i) => this.#array[i] = x ? false : this.#array[i]);
    return this.asArray();
  };

  /**
* @param {(String | Number[] | Boolean[] | Mask)} values
*/
  and = (values) => {
    let a = Mask.#toArray(values);
    let res = this.#array.map((x,i) => x && a[i]);
    return new Mask(res);
  };

  /**
* @param {(String | Number[] | Boolean[] | Mask)} values
*/
  or = (values) => {
    let a = Mask.#toArray(values);
    let res = this.#array.map((x,i) => x || a[i]);
    return new Mask(res);
  };

  /**
* @param {(String | Number[] | Boolean[] | Mask)} values
*/
  xor = (values) => {
    let a = Mask.#toArray(values);
    let res = this.#array.map((x,i) => ( x && !a[i] ) || ( !x && a[i] ));
    return new Mask(res);
  };

  /**
* @param {Number} pos
*/
  at = (pos) => this.asArray()[pos];


}

// var mask1 = new Mask('2-5|11-13|17|20-22');
// console.log(mask1.asArray());
// console.log(mask1.asString());
// var mask2 = new Mask('2-5|12|18');
// console.log(mask2.asArray());
// console.log(mask2.asString());
// mask2.remove('4-12|5');
// console.log(mask2.asArray());
// console.log(mask2.asString());

// mask3 = mask2.xor(mask1);
// console.log(mask2.asArray());
// console.log(mask2.asString());